import React from 'react';
import {injectIntl} from "react-intl";
import SAInputPercentageLabel from "../../common/input/SAInputPercentageLabel";
import SAInputDistanceLabel from "../../common/input/SAInputDistanceLabel";
import CarDamageModification from "../management/carmodification/CarDamageModification";
import SADatePicker from "../../common/input/SADatePicker";
import SATimePicker from "../../common/input/SATimePicker";
import moment from 'moment';
import Constants from "../../../services/Constants";
import SAInputComponent from "../../common/input/SAInputComponent";

class ReturnModalTab extends React.Component {

  handleBeforeUpload = (file, category) => {
    const {returnReport, returnReport: {fileList}} = this.props;
    fileList[category] = [...fileList[category], file];
    returnReport.fileList = fileList;
    returnReport[category] = [...fileList, file];
    this.updateData(returnReport);
    return false;
  };

  handleFileRemove = (file, category) => {
    const {returnReport} = this.props;
    if (file.originFileObj) {
      const fileList = returnReport.fileList;
      fileList[category] = fileList[category].filter(f => f.uid !== file.uid);
      this.updateData(returnReport);
      return;
    }
    returnReport.outdatedFiles = [...returnReport.outdatedFiles, file.uid];
    this.updateData(returnReport);
  };

  handleAttachmentsChange = ({fileList}) => {
    const {returnReport} = this.props;
    returnReport.attachments = fileList;
    this.updateData(returnReport);
  };

  onInputNumberChange = (value, name) => {
    const {returnReport} = this.props;
    returnReport[name] = value;
    this.updateData(returnReport);
  };

  onInputTextChange = (e) => {
    const {returnReport} = this.props;
    const {target: {name, value}} = e;
    returnReport[name] = value;
    this.updateData(returnReport);
  };

  onTimeChange = (e) => {
    const {returnReport} = this.props;
    returnReport.returnTime = moment(e).format(Constants.TIME_FORMAT_API);
    this.updateData(returnReport);
  };

  onDateChange = (e) => {
    const {returnReport} = this.props;
    returnReport.returnDate = moment(e).format(Constants.DATE_FORMAT_API);
    this.updateData(returnReport);
  };

  updateData = (data) => {
    const {name, onReportUpdate} = this.props;
    onReportUpdate(name, data);
  };

  render() {
    const {intl: {formatMessage}, returnReport: {fuel, mileage, advisorComment, customerComment, attachments = [], returnDate, returnTime}, errors = {}} = this.props;

    return (
      <div>
        <div className="row">
          <ul className="list col-md-6 col-xxl-6">
            <li>
              <SAInputPercentageLabel label={formatMessage({id: 'vehicle.current-fuel'})} value={fuel} error={errors.fuel}
                                      onChange={(n) => this.onInputNumberChange(n, "fuel")}/>
            </li>
            <li>
              <SAInputDistanceLabel label={formatMessage({id: 'vehicle.current-mileage'})} value={mileage} error={errors.mileage}
                                    onChange={(n) => this.onInputNumberChange(n, "mileage")}/>
            </li>
          </ul>
          <ul className="list col-md-6 col-xxl-6">
            <li>
              <SAInputComponent label={formatMessage({id: 'vehicle.return.date'})}>
                <SADatePicker value={returnDate}
                              onChange={this.onDateChange} allowClear={false} error={errors.returnDate}/>
              </SAInputComponent>
            </li>
            <li>
              <SAInputComponent label={formatMessage({id: 'vehicle.return.time'})}>
                <SATimePicker value={returnTime}
                              onChange={this.onTimeChange} allowEmpty={false} error={errors.returnTime}/>
              </SAInputComponent>
            </li>
          </ul>
        </div>

        <div className="row">
          <ul className="list col-md-12 col-xxl-12">
            <li>
              <CarDamageModification vehicle={{advisorComment, customerComment}} attachments={attachments} onInputTextChange={this.onInputTextChange}
                                     handleBeforeUpload={this.handleBeforeUpload} handleAttachmentsChange={this.handleAttachmentsChange}
                                     handleFileRemove={this.handleFileRemove} error={errors}/>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default injectIntl(ReturnModalTab);



// WEBPACK FOOTER //
// ./src/components/carpark/delivery/ReturnModalTab.js